module.exports = __webpack_public_path__ + "static/media/logo-dark.7f46fa7f.svg";